// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";

// GetLPPositions queries the LP's CKB cells and ETH pool position. Either field
// may be empty ("") to skip that chain.
@jsonObject()
export default class GetLPPositions extends PerunMessage {
  @jsonMember(String) ownerLockHash: string;
  @jsonMember(String) ethOwner: string;

  constructor(ownerLockHash: string, ethOwner: string) {
    super();
    this.ownerLockHash = ownerLockHash;
    this.ethOwner = ethOwner;
  }

  messageType(): MessageType {
    return GetLPPositions;
  }

  messageTypeName(): MessageTypeName {
    return "GetLPPositions";
  }
}
